import { all, call, put, takeEvery } from 'redux-saga/effects';
import * as types from './weaveTypeActionTypes';
import * as actions from './weaveTypeActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getWeaveTypeSaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...(action.payload || {}) };
    const { data } = yield call(endpoints.getWeaveTypes, payload);
    yield put(actions.getWeaveTypeDataAction(data));
  } catch (e) {
    yield put(actions.getWeaveTypeErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* createWeaveTypeSaga(action) {
  try {
    console.log('createWeaveTypeSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create weave type API payload:', payload);
    
    const { data } = yield call(endpoints.createWeaveType, payload);
    console.log('Create weave type API response:', data);
    
    yield put(actions.createWeaveTypeDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/weavetype');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createWeaveTypeSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createWeaveTypeErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateWeaveTypeSaga(action) {
  try {
    console.log('updateWeaveTypeSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update weave type API payload:', payload);
    
    const { data } = yield call(endpoints.updateWeaveType, payload);
    console.log('Update weave type API response:', data);
    
    yield put(actions.updateWeaveTypeDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getWeaveTypeRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/weavetype');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateWeaveTypeSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateWeaveTypeErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteWeaveTypeSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteWeaveType, action.payload.data);
    yield put(actions.deleteWeaveTypeDataAction(data));
    if (data.Result?.ErrorCode === 0) {
      yield put(actions.getWeaveTypeRequestAction());
    }
  } catch (e) {
    yield put(actions.deleteWeaveTypeErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* weaveTypeSaga() {
  yield all([
    takeEvery(types.GET_WEAVETYPE_REQUEST, getWeaveTypeSaga),
    takeEvery(types.CREATE_WEAVETYPE_REQUEST, createWeaveTypeSaga),
    takeEvery(types.UPDATE_WEAVETYPE_REQUEST, updateWeaveTypeSaga),
    takeEvery(types.DELETE_WEAVETYPE_REQUEST, deleteWeaveTypeSaga),
  ]);
}
